// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Ssv3Y","smallScreenState":"styles_smallScreenState__2bP0o"};